import { render, staticRenderFns } from "./showFold-editor.vue?vue&type=template&id=47a608a2&scoped=true"
import script from "./showFold-editor.vue?vue&type=script&lang=js"
export * from "./showFold-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a608a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47a608a2')) {
      api.createRecord('47a608a2', component.options)
    } else {
      api.reload('47a608a2', component.options)
    }
    module.hot.accept("./showFold-editor.vue?vue&type=template&id=47a608a2&scoped=true", function () {
      api.rerender('47a608a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/showFold-editor.vue"
export default component.exports